<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal
        size="l"
        :visible="modal.show"
        :data="model"
        @hidden="onHidden"
        @show="onShow"
        :title="$t('Generate BACS Payments')"
        @ok.prevent="handleSubmit(onPreview)"
        :ok-title="$t('Preview Payments')"
        :is-loading="loading"
        modal-class="mobile-full-screen"
        :disable-submit-btn="isButtonDisabled"
    >
      <input-widget rules="required" type="datepicker" :model="model" attribute="date"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "@/core/components/input-widget/InputWidget.vue";
  import SettlementService from "@/modules/settlements/SettlementService";
  import {ON_PDF_MODAL_CLOSE, ON_PDF_MODAL_DATA_RETRIEVE, ON_PDF_MODAL_OPEN} from "@/plugins/event-bus/event-bus-names";
  import i18n from "@/shared/i18n";
  import EventBus from "@/plugins/event-bus";
  import {Formatter} from "@/core/services/formatter.service";
  import BacsModel from "@/modules/bacs-payments/models/Bacs.model";

  const {mapState, mapActions} = createNamespacedHelpers('settlements');

  export default {
    name: "GenerateBacsPaymentsModal",
    components: {
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        model: new BacsModel(),
        customer: null,
        payableInfo: null,
        beneficiaries: null
      }
    },
    computed: {
      ...mapState({
        modal: state => state.generateBacsPaymentsModal,
      }),
      isButtonDisabled() {
        return !this.model.date
      }
    },
    methods: {
      ...mapActions(['hideGenerateBacsPaymentsModal', 'getTableData']),
      onHidden() {
        this.model = new BacsModel()
        this.loading = false
        this.hideGenerateBacsPaymentsModal()
      },
      onShow() {
        this.model.date = Formatter.getNowAsDate()
      },
      async onSubmit() {
        this.loading = true
        this.$evBus.$emit(ON_PDF_MODAL_OPEN, {
            title: this.$i18n.t('Payments Preview')
          });
        const data = this.generateRequestData(false)
        const resp = await SettlementService.createAndRetrieveBacsPayments(data)
        EventBus.$emit(ON_PDF_MODAL_CLOSE)
        this.loading = false
        if (resp.success) {
          this.$toast('success', this.$i18n.t('Settlement(s) were successfully paid'));
        } else {
          let errorMessage = resp.body.non_field_errors ? resp.body.non_field_errors[0] : resp.body.starting_check_number[0]
          this.$errorDialog(errorMessage);
        }
        this.hideGenerateBacsPaymentsModal()
        await this.getTableData()
      },
      async onPreview() {
        this.loading = true
        const data = this.generateRequestData(true)
        const resp = await SettlementService.createAndRetrieveBacsPayments(data)
        this.loading = false
        const actions = [
          {
            display_name: i18n.t('Confirm and Create Payments'),
            handler: this.onSubmit
          },
          {
            display_name: i18n.t('Cancel'),
            handler: () => EventBus.$emit(ON_PDF_MODAL_CLOSE)
          }]
        if (resp.success) {
          this.$evBus.$emit(ON_PDF_MODAL_OPEN, {
            title: this.$i18n.t('Payments Preview'),
            actions: actions
          });
          this.$evBus.$emit(ON_PDF_MODAL_DATA_RETRIEVE, {
            pdf_url: resp.body.pdf_url,
            filename: 'Payments Preview'
          })
        } else {
          let errorMessage = resp.body.non_field_errors ? resp.body.non_field_errors[0] : resp.body
          this.$errorDialog(errorMessage);
        }
      },
      generateRequestData(isPreview = false) {
        return {
          uuids: this.modal.selectedElements,
          preview: isPreview,
          date: this.model.date
        }
      }
    }
  }
</script>




